import { removeBenefit } from "../../infrastructure/repository/benefit-models-repository";
import { translate } from "../../infrastructure/translate/localization";
import { displayBenefitPage } from "./displays/display-benefit-page";
import { showErrorMessage } from "../commons/show-error-message";
import { showSuccessMessage } from "../commons/show-success-message";

export async function deleteBenefitModel(benefitId) {
  try {
    displayBenefitPage();
    const { data } = await removeBenefit(benefitId);

    if (data.wasSuccessful) {
      showSuccessMessage(translate("benefits-section.successfully-removed"));
    } else if (!data.wasSuccessful && data.errorReason === "last-model") {
      showSuccessMessage(
        translate("benefits-section.cant-delete-all-models-message")
      );
    } else if (!data.wasSuccessful && data.errorReason === "in-use") {
      showSuccessMessage(
        translate("benefits-section.cant-delete-a-model-applied-message")
      );
    } else {
      showErrorMessage(
        translate(
          "benefits-section.an-error-occurred-while-removing-the-benefit"
        )
      );
    }
  } catch (err) {
    showErrorMessage(
      translate(
        "benefits-section.an-error-occurred-while-removing-the-benefit"
      ),
      false,
      err
    );
  }
}
